module.exports = __webpack_public_path__ + "img/SEnvironnement_PlaineMorte-1536x864.966b6494.jpg";